module.exports = __webpack_public_path__ + "fonts/montserrat-latin-900.e66c7ed.woff2";